import TrancheField from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/TrancheField';
import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

export const LeftLeadBillingDelivering = ({ tranche }: { tranche: ITranch }) => {
  if (tranche.leftLeads?.length) {
    return <TrancheField fieldKey="leftLead" value={ tranche } />;
  }
  return <TrancheField fieldKey="billingDelivering" value={ tranche } />;
};
